<app-notification></app-notification>
<router-outlet></router-outlet>

<app-confidential-screen *ngIf="showConfidential"></app-confidential-screen>

<!-- only_desktop -->
<div class="d-none d-md-block">
    <div class="callfloat floaticons d-none d-md-block" [style.background]="themedata.cardbg">
        <img [appLazyLoadImage]="'../../assets/themes/'+themedata.theme+'/Contact.png'" alt="call"
            (click)="navigateToHelpPage()" style="width: 70%" />
    </div>
</div>

<!-- only_mobile -->
<div class="col-sm-12 d-md-none d-lg-none">
    <div class="callfloat_mobile floaticons col-sm-12 d-md-none d-lg-none" [style.background]="themedata.cardbg">
        <img [appLazyLoadImage]="'../../assets/themes/'+themedata.theme+'/Contact.png'" alt="call"
            (click)="navigateToHelpPage()" style="width: 70%" />
    </div>
</div>


<div *ngIf="environment.SHOW_CHATBOT" class="chatfloat floaticons" [style.background]="themedata.cardbg">
    <img [appLazyLoadImage]="'../../assets/themes/'+themedata.theme+'/chat.png'" alt="chat" (click)="openChatbotModal()"
        style="width: 70%" />
</div>

<div *ngIf="!isAtTop" class="scrolltopfloat d-flex jc-center align-items-center" [@fadeInAnimation]>
    <button mat-raised-button class="iconbutton" (click)="scrollToTop()" [style.background]="themedata.primarytheme" [style.color]="themedata.cardtext">
        <mat-icon>arrow_upward</mat-icon>
    </button>
</div>

<!-- only_desktop -->
<div class="d-none d-md-block">
    <div class="backbutton d-none d-md-block d-flex jc-center align-items-center" [@fadeInAnimation]>
        <button mat-raised-button class="iconbutton" (click)="goToPreviousPage()"
            [style.background]="themedata.primarytheme" [style.color]="themedata.cardtext">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>
</div>

<!-- only_mobile -->
<div class="col-sm-12 d-md-none d-lg-none">
    <div class="backbutton col-sm-12 d-md-none d-lg-none d-flex jc-center align-items-center" [@fadeInAnimation]>
        <button mat-raised-button class="iconbutton" (click)="goToPreviousPage()"
            [style.background]="themedata.primarytheme" [style.color]="themedata.cardtext">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>
</div>

<!-- <app-cookie-consent></app-cookie-consent> -->

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>